import { InjectionKey } from "vue";
import { BackendClient } from "@/backend/client";

/**
 * Type safe injection key for backend HTTP client.
 */
export const BackendKey: InjectionKey<BackendClient> = Symbol("backend");
